import React from 'react';
import { useNavigate } from 'react-router-dom';
import img from './togo.png'
const Footer = () => {
  const navigate = useNavigate();
  const navigationPage = (category) => {
    navigate(`/search-items?query=${encodeURIComponent(category)}`);
  };

  return (
    <footer className="w-full bg-gradient-to-br from-white via-gray-50 to-gray-100 border-t border-gray-200 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-16">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 rounded-2xl flex items-center justify-center mr-4 shadow-lg">
                <img
                  alt="logo"
                  src={img}
                  className="text-white text-2xl font-bold"
                ></img>
              </div>
              <div>
                <h2 className="text-2xl font-bold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent">
                  TO GO Packing Solutions
                </h2>
                <p className="text-sm text-gray-500 font-medium">
                  Custom packaging solutions
                </p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Your trusted partner for premium packaging solutions – Quality,
              Innovation, and Sustainability!
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-gray-500 text-sm">
                <svg
                  className="w-4 h-4 mr-3 text-red-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                sales@togopack.ca
              </div>
              <div className="flex items-center text-gray-500 text-sm">
                <svg
                  className="w-4 h-4 mr-3 text-red-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                +1 (613) 261-0918
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-gradient-to-r from-red-600 to-red-500 mr-3"></span>
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-gray-600 hover:text-red-600 transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  About Us
                </a>
              </li>
              {/* <li>
                <a href="" className="text-gray-600 hover:text-red-600 transition-all duration-300 flex items-center group">
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  FAQ
                </a>
              </li> */}
              <li>
                <a
                  href="/terms"
                  className="text-gray-600 hover:text-red-600 transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  href="/policy"
                  className="text-gray-600 hover:text-red-600 transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-gradient-to-r from-red-600 to-red-500 mr-3"></span>
              Categories
            </h3>
            <ul className="space-y-3">
              <li>
                <div
                  onClick={() => navigate("/search-items")}
                  className="text-gray-600 hover:text-red-600 cursor-pointer transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  All Products
                </div>
              </li>
              {/* <li>
                <div
                  onClick={() => navigationPage("paper bags")}
                  className="text-gray-600 hover:text-red-600 cursor-pointer transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  Paper Bags
                </div>
              </li> */}
              <li>
                <div
                  onClick={() => navigationPage("packing materials")}
                  className="text-gray-600 hover:text-red-600 cursor-pointer transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  Packing Materials
                </div>
              </li>
              <li>
                {/* <div
                  onClick={() => navigationPage("disposable items")}
                  className="text-gray-600 hover:text-red-600 cursor-pointer transition-all duration-300 flex items-center group"
                >
                  <span className="w-2 h-2 bg-gray-300 rounded-full mr-3 group-hover:bg-red-500 transition-colors duration-300"></span>
                  Disposable Items
                </div> */}
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-gradient-to-r from-red-600 to-red-500 mr-3"></span>
              Connect With Us
            </h3>
            <div className="space-y-4">
              <div className="flex space-x-4">
                <a
                  href="/"
                  className="w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/packingsolutions/"
                  className="w-10 h-10 bg-gradient-to-br from-pink-500 to-purple-600 rounded-xl flex items-center justify-center text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z" />
                  </svg>
                </a>
                <a
                  href="/"
                  className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
              {/* <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-4 border border-gray-200">
                <p className="text-sm text-gray-600 mb-2 font-medium">Newsletter</p>
                <div className="flex">
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  />
                  <button className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white text-sm font-medium rounded-r-lg hover:from-red-700 hover:to-red-800 transition-all duration-300">
                    Subscribe
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6">
              <span className="text-sm text-gray-600">
                © 2025{" "}
                <span className="font-semibold text-red-600">
                  TO GO Packing Solutions, INC
                </span>
                . All rights reserved.
              </span>
              <div className="hidden md:flex items-center space-x-4 text-sm text-gray-500">
                <a
                  href="/privacy"
                  className="hover:text-red-600 transition-colors duration-300"
                >
                  Privacy Policy
                </a>
                <span>•</span>
                <a
                  href="/terms"
                  className="hover:text-red-600 transition-colors duration-300"
                >
                  Terms of Service
                </a>
                <span>•</span>
                <a
                  href="/cookies"
                  className="hover:text-red-600 transition-colors duration-300"
                >
                  Cookie Policy
                </a>
              </div>
            </div>
            {/* <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-500">Made with</span>
              <div className="w-5 h-5 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center">
                <span className="text-white text-xs">❤</span>
              </div>
              <span className="text-sm text-gray-500">for you</span>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;